<mat-toolbar class="header">
  <div class="home-group">
    <button mat-icon-button (click)="navigationService.toggleNavigation()">
      <mat-icon aria-hidden="false" aria-label="Home icon" fontIcon="menu"></mat-icon>
    </button>
    <a routerLink="/home">My Application</a>
  </div>
  <app-login></app-login>
</mat-toolbar>